export default __webpack_public_path__ + "static/media/icon_calendar_important.ccf2d28f.svg";